// extracted by css-extract-rspack-plugin
export default {"quadrants":"PlKQ8EwE0VkbeBK8","quadrant":"bFHki5Rj808HkPAx","header":"dlGN3V09YvEXaDmI","title":"XYSNvoiwIQIWjLPg","link":"k3qV8pkJ63ESzPBX"};